<template>
  <div class="row-cols-lg-2" v-if="authenticated">
    <b-row no-gutters>
      <b-col class="d-block p-2 bg-mdh text-white">
        Organization <em>(select one)</em>
      </b-col>
      <b-col>
        <b-form-select
                       id="orgSelect"
                       aria-label="orgSelect"
                       label-field="orgSelect"
                       v-model="selectedOrg"
                       @input="getFacilities"
                       disabled-field="enabled"
        >
          <template #first @click="updateStore">
            <b-form-select-option value="" disabled>-- Please select an organization --</b-form-select-option>
            <b-form-select-option v-for="org in orgs" :key="org.id" :value="org"> {{org.businessName}}</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col class="d-block p-2 bg-mdh text-white">
        Facility <em>(select one)</em>
      </b-col>
      <b-col>
        <b-form-select
                       id="facilitySelect"
                       aria-label="facilitySelect"
                       label-field="facilitySelect"
                       v-model="selectedFacility"
                       @input="updateValue"
                       @change="updateStore"
                       disabled-field="enabled"
        >
          <template #first @click="updateStore">
            <b-form-select-option value="" disabled>-- Please select a facility --</b-form-select-option>
            <b-form-select-option v-for="facility in facilities" :key="facility.id" :value="facility"> {{facility.facilityName}}</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  data: () => ({
    selectedFacility: '',
    facilities: [],
    selectedOrg: '',
    orgs: [],
    pickedFacility: '',
  }),

  created() {
    if (this.value != null) {
      this.updateValue(this.value)
    }
  },
  mounted() {
  },
  computed: {
    authenticated: function() {
      if (this.$keycloak) {
        this.getOrgs()
        return this.$keycloak.authenticated;
      } else {
        return false;
      }
    },
    id() {
      if (this.setId === null) {
        return _.uniqueId('selector')
      } else {
        return this.setId
      }
    },

  },
  methods: {
    getFacilities() {
      this.clearStore()
      this.selectedFacility = null
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/facility/${this.selectedOrg.id}`).then(response => {
        this.facilities = response.data;
      })
    },
    getOrgs() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/org/allOrgs`).then(response => {
        this.orgs = response.data;
      })
    },
    updateValue(value) {
      this.$emit('input', value)
    },
    updateStore() {
      this.$store.commit("UPDATE_STATE", this.selectedFacility)
      this.$emit('change')
    },
    clearStore() {
      this.$store.commit("RESET_STATE")
    }
  },
}

</script>

<style scoped>

</style>
